module.exports = __webpack_public_path__ + "img/default-placeholder.a6a9abe7.png";